import { render, staticRenderFns } from "./TratamentoImpostos.vue?vue&type=template&id=2dedd47f&"
import script from "./TratamentoImpostos.vue?vue&type=script&lang=js&"
export * from "./TratamentoImpostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports